module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (214).e48d9d8c.jpg";